import { call, put, takeLatest } from "redux-saga/effects";
import AseguradoActions, {
  Types as AseguradoTypes,
} from "../../stores/asegurado/Actions";
import AseguradoService from "../../services/asegurado/AseguradoService";
import AuthService from "../../services/auth/AuthService";
import ResponseCode from "../../services/ResponseCode";

function* consultarAsegurado(request) {
  const { numeroSesion } = request.payload;

  yield put(AseguradoActions.consultarAseguradoLoading());

  const afiliadoResponse = yield call(
    AseguradoService.consultarAsegurado,
    AuthService.handleRequestSession(request.payload, numeroSesion)
  );

  if (!afiliadoResponse?.respuesta || afiliadoResponse?.respuesta?.codigo === ResponseCode.SERVER_ERROR.code) {
    yield put(
      AseguradoActions.consultarAseguradoFailure({
        codigo: ResponseCode.SERVER_ERROR.code,
        mensaje: ResponseCode.SERVER_ERROR.message,
      })
    );
    return;
  }

  if (afiliadoResponse?.respuesta?.codigo !== ResponseCode.OK.code) {
    yield put(
      AseguradoActions.consultarAseguradoFailure(afiliadoResponse?.respuesta)
    );
    return;
  }

  const requestValidarCc = {
    numeroPlastico: afiliadoResponse?.data?.afiliado?.numeroPlastico,
  };

  const isCcPermitido = yield call(
    AseguradoService.consultarAseguradoIsCronicoComplejo,
    AuthService.handleRequestAuth(requestValidarCc)
  );

  const { compania, afiliado } = afiliadoResponse?.data;

  yield put(
    AseguradoActions.consultarAseguradoSuccess({
      compania,
      afiliado,
      isCcPermitido
    })
  );
}

function* limpiarDatosAsegurado() {
  yield put(AseguradoActions.limpiarDatosAseguradoLoading());

  yield put(AseguradoActions.consultarAseguradoSuccess({}));
}

const exportedArray = [
  takeLatest(AseguradoTypes.CONSULTAR_ASEGURADO, consultarAsegurado),
  takeLatest(AseguradoTypes.LIMPIAR_DATOS_ASEGURADO, limpiarDatosAsegurado),
];

export default exportedArray;